import { Component, Input } from '@angular/core';

import { icons } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fin-section-review-item',
  templateUrl: 'section-review-item.component.html',
  styleUrls: ['section-review-item.component.scss'],
})
export class SectionReviewItemComponent {
  @Input()
  icon: string;

  @Input()
  category: keyof icons = 'svg-library';
}
